import styled from 'styled-components';
import media from 'styled-media-query';

const HomePageTitle = styled.h1`
  padding-top: 75px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 2.75rem;
  line-height: 3rem;
  font-weight: 700;
  color: var(--color-primary);

  ${media.lessThan('medium')`
    font-size: var(--font-size-l);
    line-height: 125%;
  `};
`;

export default HomePageTitle;
